/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Create_TitleInputs */

const vi_api_keys_create_title = /** @type {(inputs: Api_Keys_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo API Key`)
};

/**

* @param {Api_Keys_Create_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_create_title = /** @type {((inputs?: Api_Keys_Create_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Create_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_create_title(inputs)
});